import { DRAW_COMPONENT } from "../enums";

/*
 * Created Date: Tuesday January 10th 2023
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2023 Scaffcalc AB
 */
export const epsilon = 0.001;

export const anchorRadius = 0.0485;

export const braceRadius = 0.048;

export const couplerLength = 0.154;

export const couplerHeight = 0.05;

export const couplerWidth = 0.025;

export const verticalCouplerWidth = 0.025;

export const DRAW_COMPONENT_READABLE = {
  [DRAW_COMPONENT.BASECOLLARS]: {
    se: "Bottenskruv",
    en: "Base collar",
    no: "Base collar",
  },
  [DRAW_COMPONENT.BASEPLATES]: {
    se: "Bottendetalj",
    en: "Base plate",
    no: "Base plate",
  },
  [DRAW_COMPONENT.CLOTHING]: {
    se: "Inklädnad",
    en: "Clothing",
    no: "Clothing",
  },
  [DRAW_COMPONENT.COLANDERS]: {
    se: "Durkplåt",
    en: "Colander",
    no: "Colander",
  },
  [DRAW_COMPONENT.CONSOLEDECKS]: {
    se: "Konsolplank",
    en: "Console deck",
    no: "Console deck",
  },
  [DRAW_COMPONENT.CONSOLERAILPOST]: {
    se: "Konsolräcke",
    en: "Console rail post",
    no: "Console rail post",
  },
  [DRAW_COMPONENT.CONSOLES]: { se: "Konsol", en: "Console", no: "Console" },
  [DRAW_COMPONENT.COUPLER]: {
    se: "Koppling",
    en: "Coupler",
    no: "Coupler",
  },
  [DRAW_COMPONENT.DECKS]: { se: "Plank", en: "Deck", no: "Deck" },
  [DRAW_COMPONENT.DIAGONALBRACE]: {
    se: "Diagonalstag",
    en: "Diagonal brace",
    no: "Diagonal brace",
  },
  [DRAW_COMPONENT.DIAGONALBRACESX]: {
    se: "Diagonalstag",
    en: "Diagonal brace",
    no: "Diagonal brace",
  },
  [DRAW_COMPONENT.DIAGONALBRACESZ]: {
    se: "Diagonalstag",
    en: "Diagonal brace",
    no: "Diagonal brace",
  },
  [DRAW_COMPONENT.ELEVATORCABLEGUIDES]: {
    se: "Hisskabelkanal",
    en: "Elevator cable guide",
    no: "Elevator cable guide",
  },
  [DRAW_COMPONENT.ELEVATORFIXBRACKETS]: {
    se: "Hissfäste",
    en: "Elevator fix bracket",
    no: "Elevator fix bracket",
  },
  [DRAW_COMPONENT.ELEVATORFIXCOUPLERS]: {
    se: "Hisskoppling",
    en: "Elevator fix coupler",
    no: "Elevator fix coupler",
  },
  [DRAW_COMPONENT.ELEVATORFIXPIPES]: {
    se: "Hissrör",
    en: "Elevator fix pipe",
    no: "Elevator fix pipe",
  },
  [DRAW_COMPONENT.ELEVATORLANDINGCAMS]: {
    se: "Hissplatta",
    en: "Elevator landing cam",
    no: "Elevator landing cam",
  },
  [DRAW_COMPONENT.ELEVATORLANDINGEQUIPMENTS]: {
    se: "Hissutrustning",
    en: "Elevator landing equipment",
    no: "Elevator landing equipment",
  },
  [DRAW_COMPONENT.ELEVATORMASTS]: {
    se: "Hissmast",
    en: "Elevator mast",
    no: "Elevator mast",
  },
  [DRAW_COMPONENT.ELEVATORPIPES]: {
    se: "Hissrör",
    en: "Elevator pipe",
    no: "Elevator pipe",
  },
  [DRAW_COMPONENT.ELEVATORS]: {
    se: "Hiss",
    en: "Elevator",
    no: "Elevator",
  },
  [DRAW_COMPONENT.ELEVATORSLIDINGGATES]: {
    se: "Hissgaller",
    en: "Elevator sliding gate",
    no: "Elevator sliding gate",
  },
  [DRAW_COMPONENT.ELEVATORSWIVELCOUPLERS]: {
    se: "Hisskoppling",
    en: "Elevator swivel coupler",
    no: "Elevator swivel coupler",
  },
  [DRAW_COMPONENT.ELEVATORTIEINBRACKETS]: {
    se: "Hissfäste",
    en: "Elevator tie-in bracket",
    no: "Elevator tie-in bracket",
  },
  [DRAW_COMPONENT.FRAMES]: { se: "Ram", en: "Frame", no: "Frame" },
  [DRAW_COMPONENT.FRAMESUPPORT]: {
    se: "Ramstöd",
    en: "Frame support",
    no: "Frame support",
  },
  [DRAW_COMPONENT.GUARDRAIL]: {
    se: "Räcke",
    en: "Guardrail",
    no: "Guardrail",
  },
  [DRAW_COMPONENT.GUARDRAILSX]: {
    se: "Räcke",
    en: "Guardrail",
    no: "Guardrail",
  },
  [DRAW_COMPONENT.GUARDRAILSZ]: {
    se: "Räcke",
    en: "Guardrail",
    no: "Guardrail",
  },
  [DRAW_COMPONENT.LEDGER]: { se: "Stag", en: "Ledger", no: "Ledger" },
  [DRAW_COMPONENT.LEDGESX]: { se: "Stag", en: "Ledger", no: "Ledger" },
  [DRAW_COMPONENT.LEDGESZ]: { se: "Stag", en: "Ledger", no: "Ledger" },
  [DRAW_COMPONENT.LIFTOFFPREVENTER]: {
    se: "Lås",
    en: "Liftoff preventer",
    no: "Liftoff preventer",
  },
  [DRAW_COMPONENT.LOCK]: { se: "Lås", en: "Lock", no: "Lock" },
  [DRAW_COMPONENT.MESHPANEL]: {
    se: "Nätpanel",
    en: "Mesh panel",
    no: "Mesh panel",
  },
  [DRAW_COMPONENT.PIPEANCHORS]: {
    se: "Rörförankring",
    en: "Pipe anchor",
    no: "Pipe anchor",
  },
  [DRAW_COMPONENT.RAIL]: { se: "Räcke", en: "Rail", no: "Rail" },
  [DRAW_COMPONENT.RAILPOST]: {
    se: "Stolpe för räcke",
    en: "Rail post",
    no: "Rail post",
  },
  [DRAW_COMPONENT.RINGSCREW]: {
    se: "Ringbult",
    en: "Ring screw",
    no: "Ring screw",
  },
  [DRAW_COMPONENT.STAIRDECK]: {
    se: "Trapplank",
    en: "Stair deck",
    no: "Stair deck",
  },
  [DRAW_COMPONENT.STAIRFENCE]: {
    se: "Trappräcke",
    en: "Stair fence",
    no: "Stair fence",
  },
  [DRAW_COMPONENT.STAIRHATCH]: {
    se: "Trapphål",
    en: "Stair hatch",
    no: "Stair hatch",
  },
  [DRAW_COMPONENT.STAIRS]: { se: "Trappa", en: "Stair", no: "Stair" },
  [DRAW_COMPONENT.STAIRWAYGUARDRAILPOSTS]: {
    se: "Trappräcke",
    en: "Stairway guardrail",
    no: "Stairway guardrail",
  },
  [DRAW_COMPONENT.STAIRWAYGUARDRAILS]: {
    se: "Trappräcke",
    en: "Stairway guardrail",
    no: "Stairway guardrail",
  },
  [DRAW_COMPONENT.STAIRWAYGUARDRAILSINNER]: {
    se: "Trappräcke",
    en: "Stairway guardrail",
    no: "Stairway guardrail",
  },
  [DRAW_COMPONENT.STAIRWAYGUARDRAILSWIDEINNER]: {
    se: "Trappräcke",
    en: "Stairway guardrail",
    no: "Stairway guardrail",
  },
  [DRAW_COMPONENT.STAIRWAYS]: {
    se: "Trappa",
    en: "Stairway",
    no: "Stairway",
  },
  [DRAW_COMPONENT.STANDARDS]: {
    se: "Spira",
    en: "Standard",
    no: "Standard",
  },
  [DRAW_COMPONENT.TOEBOARD]: {
    se: "Sparklist",
    en: "Toeboard",
    no: "Toeboard",
  },
  [DRAW_COMPONENT.TOEBOARDSX]: {
    se: "Sparklist",
    en: "Toeboard",
    no: "Toeboard",
  },
  [DRAW_COMPONENT.TOEBOARDSZ]: {
    se: "Sparklist",
    en: "Toeboard",
    no: "Toeboard",
  },
  [DRAW_COMPONENT.TRUSSBEAMJOINT]: {
    se: "Fackverkskoppling",
    en: "Truss beam joint",
    no: "Truss beam joint",
  },
  [DRAW_COMPONENT.TRUSSBEAMS]: {
    se: "Fackverk",
    en: "Truss beam",
    no: "Truss beam",
  },
  [DRAW_COMPONENT.VANCHORS]: {
    se: "V-förankring",
    en: "V-anchor",
    no: "V-anchor",
  },
  [DRAW_COMPONENT.SOLEBOARD]: {
    se: "Underpallning (se dim. handling för dimensioner)",
    en: "Soleboard (see dim. handle for dimensions)",
    no: "Underpallning (se dim. handling för dimensioner)",
  },
};
